import { Component, OnInit, Input } from '@angular/core';
import { userModalInterface } from 'src/app/util/interfaces/userModal';
import { UserModalService } from './service/user-modal.service';
import { LabelsService } from 'src/app/util/services/labels/labels.service';
import { ProfileService } from 'src/app/services/profile/profile.service';
import { LabelsInterface } from 'src/app/util/services/labels/data/label.inteface';
import { DotBounceLoadingEffectModule } from 'src/app/page_component_item/dot-bounce-loading-effect/dot-bounce-loading-effect.module';
import { CommonModule } from '@angular/common';

@Component({
	standalone: true,
	imports: [CommonModule, DotBounceLoadingEffectModule],
	selector: 'app-user-modal',
	templateUrl: './user-modal.component.html',
	styleUrls: ['./user-modal.component.scss'],
})
export class UserModalComponent implements OnInit {
	constructor(
		private LabelsService: LabelsService,
		private UserModalService: UserModalService,
		private ProfileService: ProfileService
	) {}

	labels: LabelsInterface = {
		lbl_geral_identificacao: 'Identification',
		lbl_asset_info_usuario: 'Endusers Information',
		lbl_geral_email: 'E-mail',
		lbl_login_usuario: 'User Login',
		lbl_geral_usuario: 'Enduser',
		lbl_geral_tel_celular: 'Mobile Phone',
		lbl_geral_telefone: 'Telephone',
		lbl_geral_local: 'Local',
		lbl_asset_inventario_endereco: 'Address',
		lbl_asset_inventario_estado: 'State',
		lbl_general_registration: 'Registration',
		lbl_supervisor: 'Supervisor',
		lbl_geral_depto: 'Department',
	};

	setUserForm: userModalInterface[] = [];
	isLoadingLabels = true;

	@Input() idEnduser: string;

	isLoadingModal = true;

	ngOnInit(): void {
		this.LabelsService.getLabels().subscribe(
			(labels) => {
				this.labels = labels;
				this.isLoadingLabels = false;
			},
			(errorRes) => {
				this.isLoadingLabels = false;
			}
		);
		this.UserModalService.getSearchUserId(this.idEnduser)
			.subscribe((enduser) => {
				this.setUserForm = enduser;
			})
			.add(() => {
				//executa quando o subscribe finaliza
				this.isLoadingModal = false;
			});
	}
}
